export default class WebsocketManager {
	constructor(socketUrl, interval, value = true) {
		this.Url = socketUrl;
		this.debug = value;
		this.reconnectInterval = interval;
		this.websocket = {};
		this.reconnect = false;
		this.subscriptions = {};
		this.pendingRequests = [];
		this.OnMessage = function() {};
		this.OnOpen = function() {};
		this.OnDisconnection = function() {};
		this.OnClosure = function() {};
	}
	Connect() {
		//console.log("createWs");
		this.websocket = new WebSocket(this.Url);
		this.websocket.binaryType = "arraybuffer";
		this.websocket.onopen = function() {
			this.websocket.send(
				JSON.stringify({ topic: "connected", action: "none" })
			);
			if (this.debug) {
				if (this.reconnect) {
					console.log("[WS]: Reconnected");
					this.reconnect = false;
				} else {
					console.log("[WS]: Connected");
				}
			}
			var keys = Object.keys(this.pendingRequests);
			for (var j = 0; j < keys.length; j++) {
				var message = this.pendingRequests[keys[j]];
				if (message.action === "subscribe") {
					this.Subscribe(message.topic, message.callback);
				} else if (message.action === "unsubscribe") {
					this.Unsubscribe(message.topic);
				}
				this.pendingRequests.splice(j, 1);
			}
		}.bind(this);
		this.websocket.onclose = function(e) {
			this.OnClosure();
			switch (e) {
				// Normal closure
				case 1000:
					if (this.debug) {
						console.log("[WS]: closed: ", e);
					}
					break;
				// Abnormal closure
				default:
					if (this.debug) {
						console.log("[WS]: closed abnormally: ", e);
					}
					this.pendingRequests.concat(this.subscriptions);
					this.subscriptions = {};
					this.Reconnect(e);
					break;
			}
		}.bind(this);
		this.websocket.onerror = function(e) {
			if (this.debug) console.log("[WS]: error: ", e);
			switch (e.code) {
				// Try and reconnect
				case "ECONNREFUSED":
					this.Reconnect(e);
					break;
			}
			this.pendingRequests.concat(this.subscriptions);
			this.subscriptions = null;
		}.bind(this);
		this.websocket.onmessage = function(e) {
			let message = JSON.parse(e.data);
			let topic = this.isTopicContained(message.Topic);
			console.log("[WS]: topic: ", topic);
			if (topic !== null) {
				this.subscriptions[topic](e);
			}
		}.bind(this);
	}
	isTopicContained(topic) {
		var topicIndex = 0;
		var isContained = false;
		var keys = Object.keys(this.subscriptions);
		while (topicIndex < keys.length && !isContained) {
			if (topic === keys[topicIndex]) {
				isContained = true;
			} else {
				var keyTopic = keys[topicIndex].split(".");
				var inTopic = topic.split(".");

				var end = keyTopic.length;
				if (keyTopic[keyTopic.length - 1] === ">") {
					end = keyTopic.length - 1;
				} else if (keyTopic.length !== inTopic.length) {
					topicIndex++;
					continue;
				}
				isContained = true;
				for (var i = 0; i < end; i++) {
					if (keyTopic[i] !== inTopic[i] && keyTopic[i] !== "*") {
						topicIndex++;
						isContained = false;
						break;
					}
				}
			}
		}
		return isContained ? keys[topicIndex] : null;
	}
	Subscribe(topicToSubscribe, callback) {
		if (this.debug)
			console.log("[WS]: subscription requested to topic: ", topicToSubscribe);
		if (this.websocket.readyState === 1) {
			if (Object.keys(this.subscriptions).includes(topicToSubscribe)) {
				if (this.debug)
					console.log(
						"[WS]: subscription still active for topic: ",
						topicToSubscribe
					);
				return null;
			}
			var message = { topic: topicToSubscribe, action: "subscribe" };
			this.websocket.send(JSON.stringify(message));
			this.subscriptions[topicToSubscribe] = callback;
			if (this.debug) {
				console.log("[WS]: subscription sent for topic: ", topicToSubscribe);
			}
		} else {
			this.pendingRequests[topicToSubscribe] = {
				topic: topicToSubscribe,
				action: "subscribe",
				callback: callback,
			};
			if (this.debug)
				console.log(
					"[WS]: subscription request saved for topic: ",
					topicToSubscribe
				);
		}
	}
	Unsubscribe(topicToUnsubscribe) {
		if (this.debug)
			console.log(
				"[WS]: unsubscription requested to topic: ",
				topicToUnsubscribe
			);
		if (this.websocket.readyState === 1) {
			if (!Object.keys(this.subscriptions).includes(topicToUnsubscribe)) {
				if (this.debug)
					console.log(
						"[WS]: subscription not active for topic: ",
						topicToUnsubscribe
					);
				return null;
			}
			var message = { topic: topicToUnsubscribe, action: "unsubscribe" };
			this.websocket.send(JSON.stringify(message));
			delete this.subscriptions[topicToUnsubscribe];

			if (this.debug)
				console.log(
					"[WS]: unsubscription sent for topic: ",
					topicToUnsubscribe
				);
		} else {
			this.pendingRequests[topicToUnsubscribe] = {
				topic: topicToUnsubscribe,
				action: "unsubscribe",
			};
			if (this.debug)
				console.log(
					"[WS]: unsubscription request saved for topic: ",
					topicToUnsubscribe
				);
		}
	}
	Reconnect() {
		// Log reconnection
		if (this.debug) {
			console.log(
				`[WS]: Reconnecting in ${this.reconnectInterval / 1000} seconds.`
			);
		}
		// Set reconnect timeout
		setTimeout(
			function() {
				// Log reconnecting
				if (this.debug) {
					console.log("[WS]: Reconnecting...");
				}

				// Define has reconnected
				this.reconnect = true;

				// Try and open the URL
				this.Connect();
			}.bind(this),
			this.reconnectInterval
		);
	}

	IsConnected() {
		return this.websocket.readyState === 1;
	}
}
